/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_P2_BodyInputs */

const es_cap_p2_body = /** @type {(inputs: Cap_P2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eres tu propio jefe. Defines tu disponibilidad, tu zona y tus tarifas. Patroneas cuando quieres, lo que quieres.`)
};

const gl_cap_p2_body = /** @type {(inputs: Cap_P2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es o teu propio xefe. Defines a túa dispoñibilidade, a túa zona e as túas tarifas. Patroneas cando queres, o que queres.`)
};

const en_cap_p2_body = /** @type {(inputs: Cap_P2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are your own boss. You set availability, area, and rates. You skipper when and what you want.`)
};

/**
* | output |
* | --- |
* | "You are your own boss. You set availability, area, and rates. You skipper when and what you want." |
*
* @param {Cap_P2_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_p2_body = /** @type {((inputs?: Cap_P2_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_P2_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_p2_body(inputs)
	if (locale === "en") return en_cap_p2_body(inputs)
	return es_cap_p2_body(inputs)
});